import { InputText } from 'primereact/inputtext';
import React from 'react';
import TimezoneDatePicker from 'components/common/TimezoneDatePicker/TimezoneDatePicker';

const EverGreenStandardRetainerBillingDetailsV2 = (props) => {
  const { caseDetails, setCaseDetails, timezone } = props || {};
  return (
    <>
      <div className="row mt-4 ">
        <div className="col-12 col-md-4">Retainer Amount</div>
        <div className="col-12 col-md-8">
          <InputText
            className="input-shadow w-50 border-0 p-2"
            value={caseDetails?.billing_preferences?.retainer_amount}
            onChange={(e) => {
              if (caseDetails?.billing_preferences) {
                caseDetails.billing_preferences.retainer_amount = e.target.value;
                setCaseDetails({ ...caseDetails });
              }
            }}
            disabled
          />
        </div>
      </div>
      <div className="row mt-4 ">
        <div className="col-12 col-md-4">Retainer Date</div>
        <div className="col-12 col-md-8">
          <TimezoneDatePicker
            className="input-shadow w-50 border-0 p-2"
            onChange={(value) => {
              if (caseDetails?.billing_preferences && value) {
                caseDetails.billing_preferences.retainer_date = value;
                setCaseDetails({ ...caseDetails });
              }
            }}
            value={caseDetails?.billing_preferences?.retainer_date}
            timezone={timezone}
            isEndOfDay={true}
          />
        </div>
      </div>
    </>
  );
};

export default EverGreenStandardRetainerBillingDetailsV2;
